<form [formGroup]="form" autocomplete="off">
  <div class="row mb-2">
    <div class="col-12">
      <span class="h5 text-muted">{{ titulo }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-6" style="padding-right: 20px">
      <lib-autocomplete [schema]="carteiraSchema"></lib-autocomplete>
    </div>
  </div>
</form>
<div class="row">
  <div class="offset-sm-10 col-sm-1 offset-sm-11">
    <button
      mat-raised-button
      color="primary"
      [disabled]="form.invalid || (loading$ | async)"
      label="Pesquisar"
      type="submit" title="Pesquisar"
      aria-label="left"
      (click)="pesquisar(form.value)">
      <loading-icon [btnLabel]="'Pesquisar'" [loading]="loading$ | async"></loading-icon>
    </button>
  </div>
</div>
